import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";

/**
 * An attachment whose file was removed from My vault (EDG-590 design §12 P1): the file name stays,
 * the icon becomes a generic file, everything is greyed out, and it is neither clickable nor fetched.
 */
export const DeletedAttachmentChip = ({
  fileName,
  subtitle,
  className,
}: {
  fileName: string;
  subtitle: string;
  className?: string;
}) => (
  <div
    aria-disabled="true"
    data-testid="deleted-attachment-chip"
    className={cn(
      "flex shrink-0 cursor-default select-none items-center gap-2 rounded-3 bg-background_white_overlay5 p-1.5 pr-3",
      className,
    )}
  >
    <div className="flex size-8 shrink-0 items-center justify-center rounded-1.5 bg-background_white_overlay5">
      <Icon name="file-blank" size={20} className="text-content_quaternary" />
    </div>
    <div className="flex min-w-0 max-w-60 flex-col gap-1">
      <span className="body_s block w-full truncate text-left text-content_tertiary">
        {fileName}
      </span>
      <span className="body_xs block w-full truncate text-left text-content_quaternary">
        {subtitle}
      </span>
    </div>
  </div>
);
